import { axios } from "~/plugins/request"

export const state = () => {
  return {}
}
export const mutations = {}
export const actions = {

  templateImport ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`cityLevel/templateImport`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
// 导出
exportData({ commit }, params) {
  return new Promise((resolve, reject) => {
    axios.post(`/cityLevel/exportData`, params)
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  })
},

// 城市分级信息列表
getCityLevelVoList({ commit }, params) {
  return new Promise((resolve, reject) => {
    axios.post(`/cityLevel/getCityLevelVoList`, params)
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  })
},
}
